<template>
  <div class="">
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Pessoas</h1>
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-primary md-raised"
            @click.stop="() => toggleTab(localId)"
          >
            Cargos
          </md-button>
          <md-field>
            <md-input
              v-model="search"
              placeholder="Buscar nome"
              @input="searchOnTable"
            />
          </md-field>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Nome</md-table-head>
        <md-table-head>Nome Completo</md-table-head>
        <md-table-head>E-mail</md-table-head>
        <md-table-head>Nível de acesso</md-table-head>
        <md-table-head>Cargo</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="pessoa in searched"
        :key="pessoa.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ pessoa.userName }}</md-table-cell>
        <md-table-cell>{{ pessoa.nomeCompleto }}</md-table-cell>
        <md-table-cell>{{ pessoa.email }}</md-table-cell>
        <md-table-cell>
          <md-chip v-for="role in pessoa.roles" :key="role" class="md-primary">
            {{ role }}
          </md-chip>
        </md-table-cell>
        <md-table-cell>
          <md-chip
            v-for="cargo in pessoa.cargos"
            :key="cargo.id"
            class="md-primary"
          >
            {{ cargo.titulo }}
          </md-chip>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <slider-right id="slideLeft" ref="slider">
      <PessoaCargos :local-id="localId" />
    </slider-right>
  </div>
</template>

<script>
import PessoaCargos from '../../components/pessoa/PessoaCargos'
import SliderRight from '../../components/SliderLeft'
import http from '../../utils/http'

const toLower = (text) => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.userName).includes(toLower(term))
    )
  }

  return items
}

export default {
  name: 'PessoaIndex',
  components: {
    SliderRight,
    PessoaCargos,
  },
  data() {
    return {
      pessoas: [],
      searched: [],
      search: null,
      localId: null,
    }
  },
  beforeMount() {
    this.localId = this.$route.params.localId
  },
  async mounted() {
    this.pessoas = (await http.get(`local/${this.localId}/usuarios`)).users
    this.searched = this.pessoas
  },
  methods: {
    searchOnTable() {
      this.searched = searchByName(this.pessoas, this.search)
    },
    toggleTab(localId) {
      this.$refs.slider.toogleTab()

      this.$refs.cargos.searchCargos(localId)
    },
  },
}
</script>
